<!-- eslint-disable prettier/prettier -->
<template>
	<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :fill="color" class="ki ki-plus" viewBox="0 0 24 24"><path d="M11,11V0h2v11h11v2H13v11h-2V13H0v-2H11z"/></svg>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		width?: number;
		height?: number;
		color?: string;
	}>(),
	{
		width: 24,
		height: 24,
		color: 'currentColor'
	}
);
</script>
